/**
 * VoraLogo — Single global brand logo component.
 * Uses the exact uploaded white V logo with notch (vora-v-logo.png).
 * No SVG recreation, no approximation — image asset only.
 *
 * Usage:
 *   <VoraLogo variant="icon" size={28} />
 *   <VoraLogo variant="lockup" height={24} />
 */

export const VoraLogo = ({
  variant = "icon",
  size,
  height,
  className = "",
  ...rest
}) => {
  const h = height || size || 24;

  if (variant === "icon") {
    return (
      <img
        src="/brand/vora-v-logo.png"
        alt="VORA"
        height={h}
        className={`vora-v-img ${className}`}
        data-testid="vora-v-mark"
        draggable={false}
        style={{ objectFit: "contain", height: h, width: "auto" }}
        {...rest}
      />
    );
  }

  if (variant === "lockup") {
    return (
      <span className={`vora-lockup ${className}`} data-testid="vora-logo-lockup" {...rest}>
        <img
          src="/brand/vora-v-logo.png"
          alt="V"
          height={h}
          className="vora-v-img"
          draggable={false}
          style={{ objectFit: "contain", height: h, width: "auto" }}
        />
        <span className="vora-lockup-text" style={{ fontSize: h * 0.7 }}>VORA</span>
      </span>
    );
  }

  return (
    <img
      src="/brand/vora-v-logo.png"
      alt="VORA"
      height={h}
      className={`vora-v-img ${className}`}
      data-testid={`vora-logo-${variant}`}
      draggable={false}
      style={{ objectFit: "contain", height: h, width: "auto" }}
      {...rest}
    />
  );
};
